export const MqttEvent = {
  CONNECT: 'connect',
  ERROR: 'error',
  RECONNECT: 'reconnect',
  MESSAGE: 'message',
};
